// extracted by mini-css-extract-plugin
module.exports =  {"popper":"_93444fe79c--popper--KAN9G"};